// BOXY-665: the Problematic tab's Reason column read only
// merchant_action_required_text, which Exception orders rarely carry — 20 of 21
// showed "---" while Admin showed exception_comment. Exception falls back to it.
export const orderReasonText = (item: {
  merchant_action_required_text?: string | null;
  exception_comment?: string | null;
  status?: { slug?: string } | null;
}): string =>
  item.merchant_action_required_text ||
  (item.status?.slug === 'exception' ? item.exception_comment : '') ||
  '';
